export const FILTER_NAME = 'variant'
